import {Form, Formik} from "formik";
import React from "react";
import {SketchPicker} from "react-color";
import Card from "../../components/card/Card";
import ModalMsg from "../../components/ModalMsg";
import {getColor, getStrRgba, getTextColorForBackgroundStrRgba} from "../../utility/common";
import LabelTradotta from "../../components/LabelTradotta";
import NsField from "../../components/fields/NsField";

export default function ModificaStatoKpiView({
                                                 show,
                                                 setShow,
                                                 modalMsg,
                                                 formikRef,
                                                 SignupSchema,
                                                 aggiornaStatoKpi,
                                                 translate,
                                                 initialValuesForm,
                                                 bottoniSx,
                                                 bottoniDx,
                                                 onChangeColore,
                                             }) {

    return (
        <div>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <Formik
                initialValues={initialValuesForm}
                innerRef={formikRef}
                validationSchema={SignupSchema}
                onSubmit={aggiornaStatoKpi}
            >
                {({errors, touched, values, submitCount}) => (
                    <Form className="g-3">
                        <Card
                            icon={'fas fa-clipboard-list'}
                            title={'Modifica Stato KPI'}
                            bottoniSx={bottoniSx}
                            bottoniDx={bottoniDx}
                        >
                            <div className={'row'}>
                                <div className="col-md-6">
                                    <NsField
                                        name={"codice"}
                                        label={"Codice*:"}
                                        isDisabled={true}
                                        formikRef={formikRef}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        submitCount={submitCount}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <NsField
                                        name={"descrizione"}
                                        label={"Descrizione*:"}
                                        formikRef={formikRef}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        submitCount={submitCount}
                                    />
                                </div>
                            </div>
                            <div className={'row'}>
                                <div className="col-md-3">
                                    <LabelTradotta htmlFor={"colore"}>Colore:</LabelTradotta>
                                    <SketchPicker
                                        color={getColor(values)}
                                        onChangeComplete={onChangeColore}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <LabelTradotta htmlFor={"colore"}>Anteprima:</LabelTradotta>
                                    <div className={"ns-anteprima-colore"}
                                         style={{
                                             backgroundColor: getStrRgba(values["colore"]),
                                             color: getTextColorForBackgroundStrRgba(values["colore"])
                                         }}>
                                        {values["descrizione"] || translate('Anteprima')}
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Form>
                )}
            </Formik>
        </div>
    );
}